import type { BeamLevel } from "./projectionBeam";

/**
 * The colour the cards are lit in by the thing that projected them (KEY-532).
 *
 * The framing itself is CSS (`.kd-split[data-workspace="dynamic"]` in theme.css) rather than inline style:
 * the section level's bars fade out across the card, which needs a gradient on a pseudo-element — a border
 * cannot fade, and drawing the bars in JS would mean two extra DOM nodes per card for something CSS does
 * natively. What JS decides is only WHICH colour and WHICH level; the ladder is expressed once, in one place.
 */
export function projectionColour(level: BeamLevel, statusColour: string | null | undefined): string {
  // Neutral is the "not started" grey rather than any dial's status: with nothing selected the light is
  // coming from the dial as a whole, and borrowing a status colour would imply it came from one part of it.
  return level === "none" || !statusColour ? "var(--st-none)" : statusColour;
}
